export default __webpack_public_path__ + "static/media/ArrowCarousal.a04f71db.svg";